import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class FormValidationService {

    constructor(private translate: TranslateService) { }

    getErrorMessage(control: AbstractControl): string {

        if (control.errors?.['required']) {
            return this.translate.instant('Form.Error.Required');
        }
        if (control.errors?.['minlength']) {
            return this.translate.instant('Form.Error.Minlength', { requiredLength: control.errors['minlength']?.requiredLength });
        }
        if (control.errors?.['noSpace']) {
            return this.translate.instant('Form.Error.NoSpace');
        }
        if (control.errors?.['email']) {
            return this.translate.instant('Form.Error.Email');
        }
        if (control.errors?.['colorCode']) {
            return this.translate.instant('Form.Error.ColorCode');
        }
        if (control.errors?.['invalidImage']) {
            return this.translate.instant('Form.Error.InvalidImage');
        }
        if (control.errors?.['invalidMerchant']) {
            return this.translate.instant('Form.Error.InvalidMerchant');
        }
        if (control.errors?.['invalidDomain']) {
            return this.translate.instant('Form.Error.InvalidDomain');
        }
        if (control.errors?.['invalidPassword']) {
            return this.translate.instant('Form.Error.InvalidPassword');
        }
        if (control.errors?.['minValue']) {
            return this.translate.instant('Form.Error.MinValue', { requiredMin: control.errors['minValue']?.requiredMin });
        }

        return ''; // No error
    }
}
